import React from "react";
import Container from "./Container";
import Header from "./Header";
import Footer from "./Footer";
import Loader from "./Loader";

const Plantilla = ({ children, loader, modal }) => {
  if (loader && loader.isLoading) {
    return (
      <div className="mx-auto bg-white">
        <div className="min-h-screen flex flex-col">
          <div className="flex flex-1">
            <main className="bg-white flex-1 p-3 overflow-hidden  flex flex-wrap content-center justify-center">
              <Loader {...loader} />
            </main>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto bg-white">
      <div className="min-h-screen flex flex-col">
        <Header />
        <Container>{children}</Container>
        <Footer />
        {modal.isVisible && modal.component}
      </div>
    </div>
  );
};

Plantilla.defaultProps = {
  loader: {
    isLoading: true,
  },
  modal: {
    isVisible: false,
    component: null,
  },
};

export default Plantilla;
